import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Grid,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {useEffect, useState} from "react";
import {FullButton} from "../../../../components/button/common_button";
import CommonColorUtils from "../../../../utils/common_colors";
import LocationDropdown from "./location_dropdown";
import {TitleWithStarIcon, TitleWithOutStarIcon} from "../../../../components/tittle_with_star_icon";
import {ArrowDropDown, ArrowDropUp, Message} from "@mui/icons-material";
import {
    CommonDecimalTextField,
    CommonEmailTextField,
    CommonPhoneNumberTextField, CommonTextField
} from "../../../../components/commonTextField";
import AssignedDriverDropdown from "./assigned_driver_dropdown";
import VendorNameDropdown from "./vendor_name_dropdown";
import {
    countryListApiCall,
    driverDetailsApiCall,
    locationListApiCall,
    cityListApiCall,
    vendorDetailsApiCall, postalAreaListApiCall, createTaskApiCall
} from "../../../controllers/pick_up_order_controller";
import VendorListDropDownModel from "../../../models/vendor_list_model";
import {WarehouseList, WarehouseListModel} from "../../../models/warehouse_model";
import {DriverListModel} from "../../../models/driver_list_model";
import Skeleton from "@mui/material/Skeleton";
import CountryListModel from "../../../models/country_list_model";
import CountryDropdown from "./country_dropdown";
import CityDropdown from "./city_dropdown";
import CityListModel from "../../../models/city_list_model";
import PostalAreaDropdown from "./postal_area_dropdown";
import PostalCodeListModel from "../../../models/postal_area_list_model";
import {CreateManualTaskModel, Location, Tasks} from "../../../models/create_manual_task_model";
import {showErrorToast} from "../../../../components/toast/error_toast";
import {showSuccessToast} from "../../../../components/toast/success_toast";
import StringUtils from "../../../../utils/string_utils";


export function CreateTaskDialog({
                                     isDialogOpen,
                                     handleCloseDialog,
                                     selectedCpAwbs,
                                     taskType,
                                     hubId,
                                     hubName,
                                     selectedHub

                                 }) {

    const emailRegex =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    let firstRender = true;

    const [isApiCall, setApiCall] = useState(false);
    const [isCountryChangeFromDropdown, setIsCountryChangeFromDropdown] = useState(false);
    const [isCityChangeFromDropdown, setIsCityChangeFromDropdown] = useState(false);
    const [locationList, setLocationList] = useState([]);
    const [driverList, setDriverList] = useState([]);
    const [locationName, setLocationName] = useState('');
    const [vendorList, setvendorList] = useState([]);
    const [countryList, setCountryList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [postalAreaList, setPostalAreaList] = useState([]);
    const [locationAddress, setLocationAddress] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [selectedDriver, setSelectedDriver] = useState(null);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedPostalCode, setSelectedPostalCode] = useState(null);
    const [email, setEmail] = useState("");
    const [isEditable, setsEditable] = useState(true);
    const [hour, setHour] = useState(6);
    const [min, setMin] = useState(0);
    const [amPmText, setAmPmText] = useState("AM");
    const [returnInfoName, setReturnInfoName] = useState('');
    const [isButtonEnable, setIsButtonEnable] = useState(false);


    const fetchLocationDetailsList = async () => {
        try {
            setApiCall(true);
            const response = await locationListApiCall({hubId: hubId, deliveryType: taskType});
            if (response) {
                const warehouseListModel = WarehouseListModel.fromJson(response);
                const warehouseList = new WarehouseList();
                warehouseList.locationName = "OTHER";

                const tmpWareHouseList = [warehouseList, ...warehouseListModel.warehouseList]
                setLocationList(tmpWareHouseList);

            }
        } catch (e) {
            setLocationList([]);
        } finally {
            setApiCall(false);
        }
    };


    const fetchDriverDetailsList = async () => {
        try {
            setApiCall(true);
            const response = await driverDetailsApiCall(hubId);
            if (response) {
                const driverListModel = DriverListModel.fromJson(response);
                setDriverList(driverListModel.results ?? []);
            }
        } catch (e) {
            setDriverList([]);
        } finally {
            setApiCall(false);
        }
    };

    const fetchVendorDetailsList = async () => {
        try {
            setApiCall(true);
            const response = await vendorDetailsApiCall();
            if (response) {
                setvendorList(VendorListDropDownModel.listFromJson(response));
            }
        } catch (e) {
            setvendorList([]);
        } finally {
            setApiCall(false);
        }
    };

    const fetchCountryList = async () => {
        try {
            setApiCall(true);
            const response = await countryListApiCall();
            if (response) {
                const countryListModel = CountryListModel.fromJson(response);
                setCountryList(countryListModel.country ?? []);
                for (const country of countryListModel.country) {
                    if (country.countryCode === selectedHub.territory) {
                        setSelectedCountry(country);
                    }
                }


            }
        } catch (e) {
            setCountryList([]);
        } finally {
            setApiCall(false);
        }
    };

    const fetchCityList = async (countryCode = selectedCountry?.countryCode, isCountryChangeFromDropdown = false) => {
        try {
            if (isCountryChangeFromDropdown) {
                setIsCountryChangeFromDropdown(true);
            } else {
                setApiCall(true);
            }

            const response = await cityListApiCall(countryCode);
            if (response) {
                const cityListModel = CityListModel.fromJson(response);
                setCityList(cityListModel.city ?? []);
                return cityListModel.city ?? [];
            }
        } catch (e) {
            setCityList([]);
        } finally {
            if (isCountryChangeFromDropdown) {
                setIsCountryChangeFromDropdown(false);
            } else {
                setApiCall(false);
            }

        }
    };

    const fetchPostalAreaList = async (countryCode = selectedCountry?.countryCode, cityId, isCountryChangeFromDropdown = false, isCityChangeFromDropdown = false) => {
        try {
            if (isCountryChangeFromDropdown) {
                setIsCountryChangeFromDropdown(true);
            } else if (isCityChangeFromDropdown) {
                setIsCityChangeFromDropdown(true);
            } else {
                setApiCall(true);
            }

            const response = await postalAreaListApiCall(countryCode, cityId);
            if (response) {
                const postalCodeListModel = PostalCodeListModel.fromJson(response);
                setPostalAreaList(postalCodeListModel.area ?? []);
                return postalCodeListModel.area ?? [];
            }
        } catch (e) {
            setPostalAreaList([]);
        } finally {
            if (isCountryChangeFromDropdown) {
                setIsCountryChangeFromDropdown(false);
            } else if (isCityChangeFromDropdown) {
                setIsCityChangeFromDropdown(false);
            } else {
                setApiCall(false);
            }
        }
    };


    const fetchData = async () => {
        try {
            await fetchLocationDetailsList();
            await fetchDriverDetailsList();
            await fetchVendorDetailsList();
            await fetchCountryList();
            await fetchCityList(selectedHub?.territory);
            await fetchPostalAreaList(selectedHub?.territory);
        } catch (error) {

        }
    };

    const createManualTask = async (createManualTaskModel) => {
        try {
            setApiCall(true);
            const response = await createTaskApiCall(createManualTaskModel);
            if (response) {
                showSuccessToast(response.message)
                handleCloseDialog(undefined, undefined, true);
            }
        } catch (e) {
            const errorMessage = e.message.replaceAll("Error:", "");
            showErrorToast(errorMessage);
            setIsButtonEnable(true);
        } finally {
            setApiCall(false);
        }
    };
    useEffect(() => {
        if (firstRender) {
            fetchData();
        }
        firstRender = false;

    }, []);


    const handleLocationDropdownChange = async (e) => {
        const dropDownValue = e.target.value;
        for (const location of locationList) {

            if (location.locationName === dropDownValue) {
                setSelectedLocation(location);

                /// setting the values to default value

                setsEditable(true);
                setSelectedDriver(null);
                setLocationName("");
                setSelectedVendor(null);
                setLocationAddress("");
                setPhoneNumber("");
                setLatitude("");
                setLongitude("");
                setEmail("");
                setHour(6);
                setMin(0);
                setAmPmText("AM");
                setSelectedCountry(null);
                setReturnInfoName("");
                if (dropDownValue === "OTHER") {
                    for (const country of countryList) {
                        if (country.countryCode === selectedHub.territory) {
                            setSelectedCountry(country);
                            fetchCityList(country.countryCode);
                            fetchPostalAreaList(country.countryCode);
                        }
                    }
                }
                setSelectedCity(null);
                setSelectedPostalCode(null);

                if (dropDownValue !== "OTHER") {
                    setsEditable(false);
                    if (location?.assignedDriverUid !== null) {
                        driverList.forEach((driver) => {
                            if (driver?.uid === location?.assignedDriverUid) {

                                setSelectedDriver(driver);
                                return;
                            }
                        });
                    }
                    setLocationName(location.locationName);

                    if (location?.vendorName !== null) {
                        vendorList.forEach((vendor) => {
                            if (vendor?.vendorName === location?.vendorName) {

                                setSelectedVendor(vendor);
                                return;
                            }
                        });
                    }
                    setLocationAddress(location.locationAddress);

                    if (location?.countryId !== null) {
                        for (const country of countryList) {
                            if (country?.id === location?.countryId) {
                                setSelectedCountry(country);

                                let tmpCityList = await fetchCityList(country.countryCode);
                                if (location.cityId !== null && location.cityId !== undefined) {
                                    for (const city of tmpCityList) {

                                        if (city?.id === location.cityId) {
                                            setSelectedCity(city);
                                            setSelectedPostalCode(null);
                                            let tmpPostalAreaList = await fetchPostalAreaList(country.countryCode, city?.id);
                                            tmpPostalAreaList.forEach((Area) => {
                                                if (location.postalArea !== null && location.postalArea !== undefined) {
                                                    if (location.postalArea === Area?.postalCode) {
                                                        setSelectedPostalCode(Area);
                                                        return;
                                                    }
                                                }
                                            })

                                        }
                                    }
                                }

                            }
                        }
                    }

                    setPhoneNumber(location.phoneNumber);

                    setLatitude(location.latitude);

                    setLongitude(location.longitude);

                    setReturnInfoName(location.returnInfoName);

                    const emailList = location.email.split(",");

                    if (emailList.length !== 0) {
                        setEmail(emailList[0]);
                    } else {
                        setEmail("");
                    }

                    let [hours, min] = location?.pickupTime.split(":");

                    let hour = parseInt(hours);

                    let amOrPm = hour < 12 ? "AM" : "PM";

                    let stringHour;

                    if (hour === 12 && amOrPm === "PM") {
                        stringHour = `${hour}`;
                    } else {
                        stringHour = `${hour % 12}`;
                    }

                    if (stringHour < 10) {
                        stringHour = `0${stringHour}`; /// if the hour value
                    }

                    setHour(stringHour);
                    setMin(min);
                    setAmPmText(amOrPm);

                }


            }
        }
    }

    const handleDriverDropdownChange = (e) => {
        const dropDownValue = e.target.value;
        driverList.forEach((driver) => {

            if (driver.name === dropDownValue) {
                setSelectedDriver(driver);
                return;
            }
        });
    }

    const handleLocationNameChange = (e) => {
        const changedValue = e.target.value;
        setLocationName(changedValue);
    };

    const handleVendorNameDropdownChange = (e) => {
        const dropDownValue = e.target.value;
        vendorList.forEach((vendor) => {

            if (vendor.vendorName === dropDownValue) {
                setSelectedVendor(vendor);
                return;
            }
        });
    }

    const validationForLocationAddress = (inputValue) => {
        if (inputValue.trim() === "") {
            return {isValid: false, message: StringUtils.pleaseEnterLocationAddress};
        } else {
            return {
                isValid: true,
            };
        }
    }

    const handleCountryDropdownChange = (e) => {
        const dropDownValue = e.target.value;
        countryList.forEach((country) => {

            if (country.countryName === dropDownValue) {
                setSelectedCountry(country);
                setSelectedCity(null);
                setSelectedPostalCode(null);
                fetchCityList(country.countryCode, true);
                fetchPostalAreaList(country.countryCode, undefined, true, false);
                return;
            }
        });
    }
    const handleCityDropdownChange = (e) => {
        const dropDownValue = e.target.value;
        cityList.forEach((city) => {
            if (city.cityName === dropDownValue) {
                setSelectedCity(city);
                setSelectedPostalCode(null);
                fetchPostalAreaList(selectedCountry.countryCode, city.id, false, true);
                return;
            }
        });
    }

    const handlePostalAreaDropdownChange = (e) => {
        const dropDownValue = e.target.value;
        postalAreaList.forEach((area) => {

            if (area.postalCode === dropDownValue) {
                setSelectedPostalCode(area);

                return;
            }
        });
    }

    function handleLocationAddressChange(e) {
        const changedValue = e.target.value;
        setLocationAddress(changedValue);
    }

    const handlePhoneNumberChange = (e) => {
        const changedValue = e.target.value;
        if (/^\d*$/.test(changedValue)) {
            setPhoneNumber(changedValue);
        }
    };

    function phoneNumberValidation(inputValue) {
        if (inputValue.trim() === "") {
            return {isValid: false, message: StringUtils.phoneNumberIsRequired};
        } else if (inputValue.length < 8) {
            return {
                isValid: false,
                message: StringUtils.phoneNumberShouldHaveEightDigits,
            };
        } else {
            return {
                isValid: true,
            };
        }
    }

    const handleLatitudeChange = (e) => {
        const changedValue = e.target.value;
        if (/^\d*\.?\d*/.test(changedValue)) {
            setLatitude(changedValue);
        }
    };


    const isValidLatitude = (value) => {
        try {
            const latitudeRegExp = /^([+\-])?(?:90(?:\.0{1,6})?|(?:[0-9]|[1-8][0-9])(?:\.[0-9]{1,6})?)$/;


            if (value.trim() === "") {
                {
                    return {isValid: false, message: StringUtils.pleaseEnterLatitude};
                }
            } else if (!latitudeRegExp.test(value)) {
                return {isValid: false, message: StringUtils.invalidLatitude};
            } else {
                return {isValid: true};
            }
        } catch (error) {
            return {isValid: false, message: StringUtils.invalidLatitude};
        }
    }


    const isValidLongitude = (value) => {
        try {
            const longitudeRegExp = /^([+\-])?(?:180(?:\.0{1,6})?|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:\.[0-9]{1,6})?)$/;


            if (value.trim() === "") {
                return {isValid: false, message: StringUtils.pleaseEnterLongitude};
            } else if (!longitudeRegExp.test(value)) {
                return {isValid: false, message: StringUtils.invalidLongitude};
            } else {
                return {isValid: true, message: ""};
            }
        } catch (error) {
            return {isValid: false, message: StringUtils.invalidLongitude};
        }
    }

    const handleLongitudeChange = (e) => {
        const changedValue = e.target.value;
        if (/^\d*\.?\d*/.test(changedValue)) {
            setLongitude(changedValue);
        }
    };

    const handleEmailChange = (e) => {
        const changedValue = e.target.value;
        setEmail(changedValue);

    };

    function emailValidation(inputValue) {
        if (inputValue.trim() === "") {
            return {isValid: false, message: StringUtils.pleaseEnterEmail};
        } else if (!emailRegex.test(inputValue)) {
            return {
                isValid: false,
                message: StringUtils.invalidEmail,
            };
        } else {
            return {
                isValid: true,
            };
        }
    }


    const handleHourChange = (e) => {
        const changedValue = e.target.value;
        if (/^\d{0,2}$/.test(changedValue)) {
            setHour(changedValue);
        }

    };

    function validateHour(hourValue) {
        if (hourValue.trim() === "") {
            return {isValid: false, message: StringUtils.invalidHour};
        } else {
            const hour = Number(hourValue);
            if (hour > 12) {
                return {isValid: false, message: StringUtils.invalidHour};
            }
        }
        return {isValid: true}
    }

    const handleMinChange = (e) => {
        const changedValue = e.target.value;
        if (/^\d{0,2}$/.test(changedValue)) {
            setMin(changedValue);
        }

    };

    function validateMinute(minuteValue) {
        if (minuteValue.trim() === "") {
            return {isValid: false, message: StringUtils.invalidMinute};
        } else {
            const minute = Number(minuteValue);
            if (minute > 59) {
                return {isValid: false, message: StringUtils.invalidMinute};
            }
        }
        return {isValid: true}
    }

    const handleArrowClick = () => {
        setAmPmText((previousValue) => (previousValue === "AM" ? "PM" : "AM"));
    };


    const validateButton = () => {
        return (
            !!selectedLocation &&
            !!locationName &&
            !!selectedVendor &&
            !!locationAddress &&
            !!selectedCountry &&
            !!selectedCity &&
            !!phoneNumber &&
            !!phoneNumberValidation(phoneNumber)?.isValid &&
            !!latitude &&
            !!isValidLatitude((latitude).toString())?.isValid &&
            !!longitude &&
            !!isValidLongitude((longitude).toString())?.isValid &&
            !!email &&
            !!emailValidation(email)?.isValid
        );
    };


    useEffect(() => {
        setIsButtonEnable(validateButton());
    }, [
        selectedLocation,
        locationName,
        selectedVendor,
        locationAddress,
        selectedCountry,
        selectedCity,
        phoneNumber,
        latitude,
        longitude,
        email,
    ]);


    const handleSubmitButton = async () => {
        if (!validateHour(hour.toString())?.isValid) {
            showErrorToast(StringUtils.pleaseEnterValidHour);
            return;
        }
        if (!validateMinute(min.toString())?.isValid) {
            showErrorToast(StringUtils.pleaseEnterValidMinute);
            return;
        }


        const firstName = localStorage.getItem('firstName');
        const uid = localStorage.getItem('uid');

        const selectedTime =
            (amPmText === "PM"
                ? parseInt(hour) === 12
                    ? hour
                    : (parseInt(hour) + 12).toString()
                : parseInt(hour) === 12
                    ? ((parseInt(hour) - 12).toString() + "0").toString()
                    : hour) +
            ":" +
            min;
        const createManualTaskModel = new CreateManualTaskModel();
        const location = new Location();
        const tasks = new Tasks();
        location.type = selectedLocation.locationName === "OTHER" ? "OTHER" : null;
        location.vendorName = selectedVendor?.vendorName;
        location.vendorId = selectedVendor?.vendorId;
        location.email = email;
        location.id = selectedLocation.locationName === "OTHER" ? null : selectedLocation.locationId;
        location.name = locationName;
        location.address = locationAddress;
        location.country = selectedCountry?.countryCode;
        location.countryId = selectedCountry?.id;
        location.city = selectedCity?.cityName;
        location.cityId = selectedCity?.id;
        location.area = selectedPostalCode?.postalCode ?? selectedCity?.cityName;
        location.lat = parseFloat(latitude);
        location.lng = parseFloat(latitude);
        location.pickupTime = selectedTime;
        location.phoneCode = selectedCountry?.phoneCode;
        location.phoneNumber = parseInt(phoneNumber);
        location.originHubId = hubId;
        location.returnHubId = hubId;
        location.originHub = hubName;
        location.returnHub = hubName;
        location.returnInfoName = returnInfoName && returnInfoName.trim() !== "" ? returnInfoName : hubName;

        tasks.taskType = taskType?.toUpperCase();
        tasks.driverName = selectedDriver?.name ?? null;
        tasks.driverId = selectedDriver?.id ?? null;
        tasks.driverEmail = selectedDriver?.email ?? null;
        tasks.orders = selectedCpAwbs;

        createManualTaskModel.createdBy = firstName;
        createManualTaskModel.createdByUid = uid;
        createManualTaskModel.location = location;
        createManualTaskModel.tasks = [tasks];

        if (isButtonEnable) {
            setIsButtonEnable(false);


            await createManualTask(createManualTaskModel);
        }
    };


    const skeleton =
        (<Skeleton height={"90px"} sx={{marginBottom: "0px", marginTop: "-15px"}}/>);


    return (
        <Dialog
            open={isDialogOpen}
            onClose={handleCloseDialog}
            sx={{
                "& .MuiDialog-paper": {
                    width: "800px",
                    height: "600px",
                },
            }}
        >
            <DialogTitle>
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    <span
                        style={{
                            fontSize: "20px",
                            fontWeight: 600,
                            fontFamily: "Inter, Arial, sans-serif",
                        }}>   {"Create Task"}</span>
                    <div onClick={handleCloseDialog}>
                        <CloseIcon
                            style={{width: "24px", height: "24px", cursor: "pointer"}}
                        />
                    </div>
                </div>
            </DialogTitle>
            <DialogContent>
                <div
                    style={{
                        marginBottom: "15px",
                        textTransform: "capitalize",
                        color: CommonColorUtils.primaryGrey600,
                        fontSize: "12px",
                        fontWeight: 600,
                    }}>{`CREATE TASK FOR SELECTED ${selectedCpAwbs.length} ${taskType === "forward" ? "PICKUP" : taskType?.toUpperCase()} ORDERS`}</div>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                        <TitleWithStarIcon title={"Location"}/>

                    </Grid>

                    <Grid item xs={6}>
                        <TitleWithOutStarIcon title={"Assign Driver"}/>

                    </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                        {isApiCall ? skeleton : (
                            <LocationDropdown options={locationList} onChange={handleLocationDropdownChange}
                                              selectedValue={selectedLocation?.locationName} sx={{
                                marginBottom: "15px",
                            }}/>)}
                    </Grid>

                    <Grid item xs={6}>
                        {isApiCall ? skeleton :
                            <AssignedDriverDropdown options={driverList} onChange={handleDriverDropdownChange}
                                                    selectedValue={selectedDriver?.name} sx={{
                                marginBottom: "15px",
                            }}/>}
                    </Grid>

                </Grid>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                        <TitleWithStarIcon title={"Location Name"}/>

                    </Grid>

                    <Grid item xs={6}>
                        <TitleWithStarIcon title={"Vendor Name"}/>

                    </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                        {isApiCall ? skeleton :
                            <CommonTextField
                                label=""
                                inputValue={locationName}
                                onHandleChange={handleLocationNameChange}
                                disabled={!isEditable}
                                sx={{marginTop: "5px", marginBottom: "15px"}}
                            />}
                    </Grid>

                    <Grid item xs={6}>
                        {isApiCall ? skeleton :
                            <VendorNameDropdown options={vendorList} onChange={handleVendorNameDropdownChange}
                                                selectedValue={selectedVendor?.vendorName}
                                                isDisable={!isEditable} sx={{
                                marginBottom: "15px",
                            }}/>}
                    </Grid>

                </Grid>
                <TitleWithStarIcon title={"Location Address"}/>
                {isApiCall ? skeleton :
                    <CommonTextField
                        label=""
                        inputValue={locationAddress}
                        onHandleChange={handleLocationAddressChange}
                        validator={validationForLocationAddress}
                        disabled={!isEditable}
                        sx={{marginBottom: "15px", marginTop: "5px"}}
                    />}
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                        <TitleWithStarIcon title={"Country"}/>

                    </Grid>

                    <Grid item xs={6}>
                        <TitleWithStarIcon title={"City"}/>

                    </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                        {isApiCall ? skeleton :
                            <CountryDropdown options={countryList} onChange={handleCountryDropdownChange}
                                             selectedValue={selectedCountry?.countryName} isDisable={true} sx={{
                                marginBottom: "15px",

                            }}/>}
                    </Grid>

                    <Grid item xs={6}>
                        {(isApiCall || isCountryChangeFromDropdown) ? skeleton :
                            <CityDropdown options={cityList} onChange={handleCityDropdownChange}
                                          selectedValue={selectedCity?.cityName} isDisable={!isEditable} sx={{
                                marginBottom: "15px",
                            }}/>}
                    </Grid>

                </Grid>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                        <TitleWithOutStarIcon title={"Area/Postal Code"}/>

                    </Grid>

                    <Grid item xs={6}>
                        <TitleWithStarIcon title={"Phone No."}/>

                    </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                        {(isApiCall || isCountryChangeFromDropdown || isCityChangeFromDropdown) ? skeleton :
                            <PostalAreaDropdown options={postalAreaList} onChange={handlePostalAreaDropdownChange}
                                                selectedValue={selectedPostalCode?.postalCode} isDisable={!isEditable}
                                                sx={{
                                                    marginBottom: "5px",
                                                }}/>}
                    </Grid>

                    <Grid item xs={6}>
                        {isApiCall ? skeleton : <CommonPhoneNumberTextField
                            label=""
                            inputValue={phoneNumber}
                            onHandleChange={handlePhoneNumberChange}
                            validator={phoneNumberValidation}
                            disabled={!isEditable}
                            sx={{marginTop: "5px", marginBottom: "5px"}}
                        />}
                    </Grid>

                </Grid>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                        <TitleWithStarIcon title={"Latitude"} marginTop={"10px"}/>

                    </Grid>

                    <Grid item xs={6}>
                        <TitleWithStarIcon title={"Longitude"} marginTop={"10px"}/>

                    </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                        {isApiCall ? skeleton : <CommonDecimalTextField
                            label=""
                            inputValue={latitude}
                            onHandleChange={handleLatitudeChange}
                            validator={isValidLatitude}
                            disabled={!isEditable}
                            sx={{marginTop: "5px"}}
                        />}
                    </Grid>

                    <Grid item xs={6}>
                        {isApiCall ? skeleton : <CommonDecimalTextField
                            label=""
                            inputValue={longitude}
                            onHandleChange={handleLongitudeChange}
                            validator={isValidLongitude}
                            disabled={!isEditable}
                            sx={{marginTop: "5px"}}
                        />}
                    </Grid>

                </Grid>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                        <TitleWithStarIcon title={"Email"} marginTop={"10px"}/>

                    </Grid>

                    <Grid item xs={6}>
                        <TitleWithStarIcon title={"Pickup Time"} marginTop={"10px"}/>

                    </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                        {isApiCall ? skeleton : <CommonEmailTextField
                            label=""
                            inputValue={email}
                            onHandleChange={handleEmailChange}
                            validator={emailValidation}
                            disabled={!isEditable}
                            sx={{marginTop: "10px", marginBottom: "15px"}}
                        />}
                    </Grid>

                    {isApiCall ? <Grid item xs={6}>
                        {skeleton}
                    </Grid> : <>
                        <Grid item xs={1.8}>
                            <CommonPhoneNumberTextField
                                label="Hour"
                                inputValue={hour}
                                onHandleChange={handleHourChange}
                                // validator={validateHour}
                                maxLength={2}
                                disabled={!isEditable}
                                sx={{marginTop: "0px"}}
                            />
                        </Grid>
                        <Grid item xs={1.8}>
                            <CommonPhoneNumberTextField
                                label="Minute"
                                inputValue={min}
                                onHandleChange={handleMinChange}
                                // validator={validateMinute}
                                maxLength={2}
                                disabled={!isEditable}
                                sx={{marginTop: "0px"}}
                            />
                        </Grid>
                        <Grid item xs={2.4}>
                            <CommonEmailTextField
                                label=""
                                inputValue={amPmText}
                                otherProps={{readOnly: true}}
                                sx={{marginTop: "0px"}}
                                disabled={!isEditable}
                                endAdornmentIcons={
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                        }}
                                    >
                                        <IconButton
                                            size="small"
                                            onClick={handleArrowClick}
                                            style={{paddingTop: "20px", paddingRight: "5px"}}
                                            disabled={!isEditable}
                                        >
                                            <ArrowDropUp/>
                                        </IconButton>
                                        <IconButton
                                            size="small"
                                            onClick={handleArrowClick}
                                            style={{paddingBottom: "20px"}}
                                            disabled={!isEditable}
                                        >
                                            <ArrowDropDown/>
                                        </IconButton>
                                    </div>
                                }
                            />

                        </Grid>
                    </>}
                </Grid>
            </DialogContent>
            <DialogActions>
                <div style={{display: "flex", gap: "10px", marginRight: "10px"}}>
                    <button
                        style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            border: `1px solid ${CommonColorUtils.primaryGrey300}`,
                            height: 48,
                            width: "100px",
                        }}
                        onClick={handleCloseDialog}
                    >
            <span style={{fontWeight: 600, fontSize: "14px", color: "black"}}>
              Cancel
            </span>
                    </button>

                    <FullButton
                        buttonText={"Submit"}
                        activeColor={CommonColorUtils.primaryMainBlue}
                        inactiveColor={CommonColorUtils.primaryMainBlueDisabledColor}
                        buttonTextColor={CommonColorUtils.primaryKWhite}
                        active={isButtonEnable}
                        height={"48px"}
                        width={"100px"}
                        customCursor={isButtonEnable ? "pointer" : "default"}
                        isDisable={!isButtonEnable}
                        handleOnPress={handleSubmitButton}
                    />
                </div>
            </DialogActions>
        </Dialog>
    );
}
